import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import type { VenueInfoResponse, VenueInfoData } from '@/types';

const fetchVenueInfoData = (venueId: string | number | undefined): Promise<VenueInfoData> =>
  axios<VenueInfoResponse>({
    url: `/api/venues/infomodal/${venueId}`,
  }).then((res) => {
    const data = res.data;
    const hasAnyVenueData = !!(
      data.awards?.length ||
      data.servingHours?.length ||
      (data.hygieneRating && data.venueCountry)
    );
    return { ...data, hasAnyVenueData };
  });

export const useVenueInfoQuery = (venueId: string | number | undefined) => {
  return useQuery({
    queryKey: ['venue-info', venueId],
    queryFn: () => fetchVenueInfoData(venueId),
    retry: 3,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 60 * 24,
  });
};
